var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-bottom-sheet', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "content-class": "bottom-sheet"
    },
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "bottom-sheet__card",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "bottom-sheet__card__head primary"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": "",
      "absolute": "",
      "right": "",
      "color": "white"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('v-layout', _vm._b({
    staticClass: "bottom-sheet__card__body",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, 'v-layout', {
    style: _vm.style_body
  }, false), [_vm._t("default")], 2), !_vm.hideFoot ? [_c('v-divider'), _c('v-layout', {
    staticClass: "bottom-sheet__card__foot",
    attrs: {
      "justify-center": ""
    }
  }, [_vm._t("foot")], 2)] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }